// Én besked ad gangen. Toasten, hændelseskortet, trænerens hånd og Volts taleboble deler én kø:
// hver frame vinder den vigtigste, der vil frem, og de andre venter (eller udløber). Rækkefølgen:
// udfald > kort > svar > guide > Volt > toast. "Svar" er toasten, når den svarer på noget, spilleren
// selv lige gjorde (fx "Fortrudt."): det er et svar, ikke en besked, så det går foran hånden og Volt,
// men aldrig foran et udfald eller et åbent kort.

import type { Rect } from '../render/camera';
import type { P } from '../render/geo';

export type Channel = 'udfald' | 'kort' | 'svar' | 'guide' | 'volt' | 'toast';

/** Vigtigst først. */
export const ORDER: readonly Channel[] = ['udfald', 'kort', 'svar', 'guide', 'volt', 'toast'];

/** En ventende besked udløber, hvis den ikke er kommet frem inden for 6 s. */
export const QUEUE_MS = 6000;

/** Toastens prioritet (Toast.wantPrio) som kanal: 4 udfald, 3 svar, 1-2 almindelig toast, 0 ingen. */
export function toastChannel(prio: number): Channel | null {
  if (prio >= 4) return 'udfald';
  if (prio === 3) return 'svar';
  return prio > 0 ? 'toast' : null;
}

/** Den kanal, der får lov at vise sig lige nu (null, når ingen vil frem). */
export function arbitrate(want: Partial<Record<Channel, boolean>>): Channel | null {
  for (const c of ORDER) if (want[c]) return c;
  return null;
}

/** Ligger et af punkterne under rektanglet (med `pad` px luft)? */
export function covers(r: Rect | null, pts: readonly P[], pad = 20): boolean {
  if (!r) return false;
  return pts.some((p) => p.x > r.x - pad && p.x < r.x + r.w + pad && p.y > r.y - pad && p.y < r.y + r.h + pad);
}
